import * as actionTypes from '../types/configurator';

const initialState = {
  availableOperations: [],
  operations: [],
  skuAttributes: [],
  allAttributes: [],
  inheritTypes: [],
  getAvailableOperations: {
    loading: false,
    okRequest: false
  },
  saveAvailableOperation: {
    loading: false,
    okRequest: false
  },
  getSkuAttributes: {
    loading: false,
    okRequest: false
  },
  saveAttributes: {
    loading: false,
    okRequest: false
  },
  error: false,
  loading: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_AVAILABLE_OPERATIONS:
      return {
        ...state,
        loading: true,
        error: false,
        getAvailableOperations: {
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.GET_AVAILABLE_OPERATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        availableOperations: payload,
        getAvailableOperations: {
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.GET_AVAILABLE_OPERATIONS_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        getAvailableOperations: {
          loading: false,
          okRequest: false
        }
      };
    case actionTypes.GET_ALL_OPERATIONS:
      return {
        ...state,
        loading: true,
        error: false,
        getAvailableOperations: {
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.GET_ALL_OPERATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        operations: payload,
        getAvailableOperations: {
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.GET_ALL_OPERATIONS_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        getAvailableOperations: {
          loading: false,
          okRequest: false
        }
      };
    case actionTypes.GET_SKU_ATTRIBUTES:
      return {
        ...state,
        loading: true,
        error: false,
        getSkuAttributes: {
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.GET_SKU_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        loading: false,
        skuAttributes: payload,
        getSkuAttributes: {
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.GET_SKU_ATTRIBUTES_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        getSkuAttributes: {
          loading: false,
          okRequest: false
        }
      };
    case actionTypes.GET_ALL_ATTRIBUTES:
      return {
        ...state,
        loading: true,
        error: false,
        getSkuAttributes: {
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.GET_ALL_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        loading: false,
        allAttributes: payload,
        getSkuAttributes: {
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.GET_ALL_ATTRIBUTES_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        getSkuAttributes: {
          loading: false,
          okRequest: false
        }
      };
    case actionTypes.GET_INHERIT_TYPES:
      return {
        ...state,
        loading: true,
        error: false
      };
    case actionTypes.GET_INHERIT_TYPES_SUCCESS:
      return {
        ...state,
        loading: false,
        inheritTypes: payload
      };
    case actionTypes.GET_INHERIT_TYPES_FAIL:
      return {
        ...state,
        loading: false,
        error: true
      };
    case actionTypes.SAVE_AVAILABLE_OPERATIONS:
      return {
        ...state,
        loading: true,
        error: false,
        saveAvailableOperation: {
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.SAVE_AVAILABLE_OPERATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        saveAvailableOperation: {
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.SAVE_AVAILABLE_OPERATIONS_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        saveAvailableOperation: {
          loading: false,
          okRequest: false
        }
      };
    case actionTypes.SAVE_SKU_ATTRIBUTES:
      return {
        ...state,
        loading: true,
        error: false,
        saveAttributes: {
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.SAVE_SKU_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        saveAttributes: {
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.SAVE_SKU_ATTRIBUTES_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        saveAttributes: {
          loading: false,
          okRequest: false
        }
      };
    case actionTypes.DELETE_ATTR:
      return {
        ...state,
        loading: true,
        error: false,
        saveAttributes: {
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.DELETE_ATTR_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        saveAttributes: {
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.DELETE_ATTR_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        saveAttributes: {
          loading: false,
          okRequest: false
        }
      };
    default:
      return state;
  }
};

export default reducer;
